<script>
    /*
    	ApiArrayField.svelte

        Things to keep in mind:

            Needs a store so array of chips can be reactive
    */

    import { onMount } from 'svelte';
    import { getFieldStyle } from '../../common/data-fields.js';

    // TCARE components
    import ApiArrayFieldEditor from './ApiArrayFieldEditor.svelte';

    // SMUI components
    import Tooltip, { Wrapper } from '@smui/tooltip';
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiPencil, mdiClose, mdiArrowRight, mdiChevronRightBox } from '@mdi/js';
    import { delimitArray, dedupeSimpleArray, shallowArraysEqual } from "../../common/utils.js";

    export let value;           // bind:value={apiData[ADDITIONAL_INFO]}
    export let choices;         // preset values from API call in fieldPresetsStore
    export let store;           // the service object with .apiData
    export let propName;        // a constant in constants.js
    export let label;           // displayed on the field
    export let isEditable;
    export let isOrigDiff;
    export let isNewDiff;
    export let onCopyValue;
    export let tooltip;
    export let showDiffs;       // bypass the strike-through and highlighting

    export let isUserInput;     // pass-through to Editor
    export let isUserSelect;    // pass-through to Editor

    $: formattedValue = getFormattedValue(value);
    $: isDirty = value ? !shallowArraysEqual(originalValue, value) : false;
    $: valueWidth = getValueWidth(isEditable, isDirty);
    $: fieldStyle = getFieldStyle(isEditable, isOrigDiff, isNewDiff, isDirty, showDiffs);
    $: isShowingEditor = false;

    let originalValue;

    onMount(() => {

        if (value) {
            originalValue = [...value];         // copy the array
        } else {
            value = [];
            originalValue = [];
        }

        // console.log('');
        // console.log('ApiArrayField onMount');
        // console.log('propName: ', propName);
        // console.log('value: ', value);
        // console.log('choices: ', choices);
        // console.log('$store: ', $store);

    });

    const resetValue = () => {
        value = originalValue ? [...originalValue] : null;      // this should change the source array because it is bound
    }

    const getFormattedValue = (val) => {
        if(!val || val.length === 0) return  ''
        // if (!val || val.length === 0) return '[empty array]';
        return delimitArray(val);       // or fill with chips?
    }

    const getValueWidth = (isEditable, isDirty) => {
        let style = '';
        return style;
    }

    const _onCopyValue = () => {
        if (onCopyValue) onCopyValue(propName);              // call parent function
    }

    const onShowEditor = () => {
        isShowingEditor = true;
    }


    // passed to the DataArrayFieldEditor popup dialog
    const onHideEditor = () => {
        isShowingEditor = false;
        document.querySelector("body").classList.remove("mdc-dialog-scroll-lock");      // hack
    }

</script>

<style>


    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="data-field">
    <div class="label">
        {label}
    </div>

    <div class="value" style={valueWidth}>
        <Wrapper>
            <div class="fake-input" style={fieldStyle}>
                {formattedValue}
            </div>
            {#if tooltip && tooltip !== '' && tooltip.length > 0}
                <Tooltip xPos="start" yPos="above">{tooltip}</Tooltip>
            {/if}
        </Wrapper>
    </div>

    <div class="icons">

        <!-- the "copy to" icon - call parent's function -->
        {#if onCopyValue}
            {#if value && value.length > 0}
                <div class="icon" on:click={_onCopyValue}>
                    <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiChevronRightBox} /></Icon>
                </div>
            {/if}
        {/if}

        {#if isEditable}
            <div class="icon" on:click={onShowEditor}>
                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiPencil} /></Icon>
            </div>
        {/if}

        {#if isEditable && isDirty}
            <div class="icon" on:click={() => resetValue()}>
                <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiClose} /></Icon>
            </div>
        {/if}
    </div>
</div>

<!-- this will only mount Dialog if isShowingEditor is true -->
{#if isShowingEditor}

    <ApiArrayFieldEditor 
        bind:value={value}
        {choices}
        {store}
        {propName}
        {onHideEditor}
        {label}
        {isUserInput}
        {isUserSelect}
    />

{/if}

